import React from "react";
import { cx } from "components/crm/ui/uiUtils";

const TAGS = {
  neutral: "bg-surfaceMuted text-body",
  orange: "bg-tagOrange-bg text-tagOrange-fg",
  success: "bg-success text-success-bg",
  successSoft: "bg-success-bg text-success-text",
  danger: "bg-danger-bg text-danger",
  primary: "bg-primary-tint text-primary-dark",
};

// `title` switches the text to the title font (kept under the prototype's name).
const Tag = ({ tone = "neutral", children, title: font }) => (
  <span
    className={cx(
      "inline-flex items-center rounded px-2 py-[2px] text-xs font-medium leading-4 whitespace-nowrap",
      font && "font-title",
      TAGS[tone]
    )}
  >
    {children}
  </span>
);

export default Tag;
